The title that the person held for this position.
